import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Sidebars from "../Sidebar/Sidebars";
import "../Dashboard.css";

const ProtectedRoute = ({
  component: Component,
  role,
  userData,
  allowedRoles,
  onChildData,
  mainId,
  token,
  userDetail
}) => {
const [sidebar, setSidebar] = useState(true);

const handleSidebar = () => {
  setSidebar(!sidebar)
}
  return (
    <div className="App">
      <div style={{display: "grid",
    height: "100%",
    width: "100%",
    background: "var(--glass)",
    gridTemplateColumns: `${sidebar? '15rem' : '4.2rem'} auto 0rem`,
    overflow: "hidden",
    transition: "grid-template-columns 0.15s ease-in-out",
  }}
      >
        <div style={{width: sidebar? "21rem" : "5rem" }}>
        <Sidebars
          userData={userData}
          userDetail={userDetail}
          role={role}
          sidebar = {sidebar}
        />
        </div>
        <div
          className="MainDash"
        >
          <Navbar 
          userData={userData}
          handleSidebar = {handleSidebar}
          sidebar = {sidebar}
          />
          <Component
            userData={userData}
            onChildData={onChildData}
            mainId={mainId}
            token={token}
            userDetail={userDetail}
          />
        </div>
      </div>
    </div>
  );
};

export default ProtectedRoute;
